var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-4" }, [
    _c("div", { staticClass: "rounded-md bg-yellow-50 p-4" }, [
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "flex-shrink-0" }, [
          _c(
            "svg",
            {
              staticClass: "h-5 w-5 text-yellow-400",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                "aria-hidden": "true"
              }
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  d:
                    "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                  "clip-rule": "evenodd"
                }
              })
            ]
          )
        ]),
        _c("div", { staticClass: "ml-3 flex-1 md:flex md:justify-between" }, [
          _c("p", { staticClass: "text-sm text-yellow-700" }, [
            _vm._v(
              ' Are you are getting "Phone number shared via url is invalid" while you try to send? '
            )
          ]),
          _c("p", { staticClass: "mt-3 text-sm md:mt-0 md:ml-6" }, [
            _c(
              "a",
              {
                staticClass:
                  "whitespace-nowrap font-medium text-yellow-700 hover:text-yellow-600 cursor-pointer",
                on: { click: _vm.gotoManualMessageError }
              },
              [
                _vm._v("View Solution "),
                _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("→")])
              ]
            )
          ])
        ])
      ])
    ]),
    _vm.isShopifyWebview
      ? _c("div", { staticClass: "rounded-md bg-red-50 p-4" }, [
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "flex-shrink-0" }, [
              _c(
                "svg",
                {
                  staticClass: "h-5 w-5 text-red-400",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      d:
                        "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                      "clip-rule": "evenodd"
                    }
                  })
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "ml-3 flex-1 md:flex md:justify-between" },
              [
                _c("p", { staticClass: "text-sm text-red-700" }, [
                  _vm._v(
                    " It seems you are using our app on Shopify mobile app, which will block popups by default. So manual messages can't be sent within the app. We recommend opening our app in the browser. "
                  )
                ]),
                _c("p", { staticClass: "mt-3 text-sm md:mt-0 md:ml-6" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "whitespace-nowrap font-medium text-yellow-700 hover:text-yellow-600",
                      attrs: { href: _vm.authUrl, target: "_blank" }
                    },
                    [
                      _vm._v("Open in Browser "),
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("→")
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }